<template>
  <div
    class="mask"
    v-if="visible"
    :style="{ zIndex: overlayZIndex }"
    @click.self="handleCancel"
  >
    <div class="flex flex-col c-box" :style="{ zIndex: overlayZIndex + 1 }">
      <div class="header-box">
        <h4>预览</h4>
        <span class="close-box" @click="handleCancel">×</span>
      </div>
      <div class="centent-box" style="text-align: center; flex: 1;height:0">
        <template v-if="fileType == 'img'">
          <div class="img-box">
            <img :src="baseURL + imgUrl" alt="" class="image" />
          </div>
        </template>
        <template v-else-if="fileType == 'pdf'">
          <iframe
            :src="baseURL + pdfUrl"
            style="width: 100%; height: 100%"
            frameborder="0"
          ></iframe>
        </template>
        <template v-else>
          <div class="d-text">
            <img
              src="@/assets/images/img55.png"
              style="width: 200px; margin-bottom: 20px"
              alt=""
            />
            <p>该格式暂不支持预览，请下载后预览</p>
            <p>
              <a-button @click="downLoadFile(fileUrl)">点击下载</a-button>
            </p>  
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";
export default {
  props: {
    overlayZIndex: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      baseURL,
      fileType: "",
      imgUrl: "",
      pdfUrl: "",
      fileUrl: "",
    };
  },
  methods: {
    handleCancel() {
      this.visible = false;
    },
    init(scoreFile) {
      this.visible = true;
      console.log(scoreFile, "scoreFile");
      const type = scoreFile.split(".").pop().toLowerCase();
      const officeTypes = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
      if (type == "jpg" || type == "png" || type == "jpeg") {
        this.fileType = "img";
        this.imgUrl = scoreFile;
      } else if (type == "pdf") {
        this.fileType = "pdf";
        this.pdfUrl = scoreFile;
      } else if (
        scoreFile.indexOf("http://office.hxpxxy.com") !== -1 ||
        scoreFile.indexOf("https://office.hxpxxy.com") !== -1
      ) {
        this.fileType = "pdf";
        this.pdfUrl = scoreFile;
      } else if (officeTypes.includes(type)) {
        this.fileType = "pdf";
        this.pdfUrl = scoreFile.substring(0, scoreFile.lastIndexOf(".")) + ".pdf";
      } else {
        this.fileType = "file";
        this.fileUrl = scoreFile;
      }
    },
    downLoadFile(url) {
      window.open(baseURL + url);
    },
  },
};
</script>

<style scoped lang="scss">
.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.c-box {
  width: 80%;
  height: 90vh;
  background: url("~@/assets/images/img19.png") no-repeat;
  background-size: 100% 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.header-box {
  height: 80px;
  line-height: 78px;
  text-align: right;
  padding-right: 20px;
  background: #9A0B00;
  border-radius: 15px 15px 0 0;
  margin: 0 1.5% 0 0.7%;
  font-size: 28px;
  color: #fff;
  position: relative;
  h4{
    text-align: center;
    color: #fff;
  }
  .close-box{
    position: absolute;
    top: 5px;
    right: 20px;
    cursor: pointer;
  }
  // cursor: pointer;
}
.centent-box {
  padding: 20px;
  padding-right: 35px;
  box-sizing: border-box;
}
.img-box{
  height: 100%;
  overflow: auto;
}
.d-text {
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
  font-size: 16px;
  color: #666;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.image {
  width: auto;
  height: auto;
  max-width: 100%;
}
</style>
